"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardTracker = void 0;
const error_message_1 = require("../../enums/error-message");
class CardTracker {
    constructor(tracker) {
        this.tracker = tracker;
    }
    trackClick(trackingData, eventParams) {
        var _a;
        if (this.tracker === null) {
            throw new Error(error_message_1.ErrorMessage.DATA_LAYER_TRACKER_UNAVAILABLE);
        }
        this.tracker.trackECommerceClickEvent({
            eventParams,
            listEntityType: this.getListEntityType(),
            listName: (_a = trackingData.listName) !== null && _a !== void 0 ? _a : '',
            listPageType: trackingData.listPageType,
            item: trackingData.getTrackingContext()
        });
    }
    trackImpression(trackingData, eventParams) {
        var _a, _b;
        if (this.tracker === null) {
            throw new Error(error_message_1.ErrorMessage.DATA_LAYER_TRACKER_UNAVAILABLE);
        }
        this.tracker.trackECommerceImpressionEvent({
            eventParams,
            listEntityType: this.getListEntityType(),
            listName: (_a = trackingData.listName) !== null && _a !== void 0 ? _a : '',
            listPageType: (_b = trackingData.listPageType) !== null && _b !== void 0 ? _b : '',
            item: trackingData.getTrackingContext()
        });
    }
}
exports.CardTracker = CardTracker;
